import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Title,
  Tooltip,
  Chart as chartJS,
} from 'chart.js';
import LineChart from './LineChart';
import Circularprogressbar from './Circularprogressbar';
import DoublebarChart from './DoublebarChart';
import { useSelector } from 'react-redux';
import { CalculationBalance } from '../redux/userSlice';
import addicon from "../assets/images/addicon.svg";
chartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Page2 = () => {

  const  CalculationResponse = useSelector(CalculationBalance);

  // console.log("CalculationResponse",CalculationResponse[0])
  
  // if(!CalculationResponse){
  //   return <p>calculate Rsik level</p>
  // }
 

  // Sample JSON data
  const jsonData = {
    "data": [
      {"label": "Aggressive", "value":  CalculationResponse?parseFloat(CalculationResponse?.aggressiveDRPT):0, "startColor": 'rgb(103, 222, 109)', "endColor": 'rgba(181, 222, 181, 1)'},
      {"label": "Neutral", "value": CalculationResponse?parseFloat(CalculationResponse?.neutralDRPT):0, "startColor": 'rgb(108, 172, 248)', "endColor": 'rgba(210, 222, 236, 1)'},
      {"label": "Conservatives", "value": CalculationResponse?parseFloat(CalculationResponse?.conservativeDRPT):0, "startColor": 'rgb(235, 104, 105)', "endColor": 'rgba(209, 162, 165, 1)'}
    ]
  };
  const createGradient = (startColor, endColor) => {
    const ctx = document.createElement('canvas').getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 250);
    gradient.addColorStop(0, startColor);
    gradient.addColorStop(1, endColor);
    return gradient;
  };

  // Transform JSON data into chart data format
  const barChartData = {
    labels: jsonData.data.map(item => item.label),
    datasets: [
      {
        
        barPercentage: 0.7,
        categoryPercentage: 0.6,
        data: jsonData.data.map(item => item.value),
        backgroundColor: jsonData.data.map(item => item.startColor),
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,

    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
       
      },
      y: { 
        
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      
    }
  };

  return (
    <>
  
        {/* <Bar options={options} data={barChartData} /> */}
        {CalculationResponse?<>
          
        <div className='pchartcnv' style={{ height: '286px' ,paddingTop:'15px'}}> {/* Set the height of the parent div */}
        
        <Bar options={options} data={barChartData} height={400} /> {/* Set the height of the canvas */}
      </div>
      </>:<h3 style={{paddingTop:'15px'}}>No risk level data</h3>}
      <ul className='pchartlist'>
        {jsonData.data.map((item, index) => (
          <li key={index}  >
            <p>{item.label} </p><h6 style={{ color: item.startColor }}> ${item.value}</h6>
          </li>
        ))}
      </ul>
      {/* <LineChart/>
      <Circularprogressbar/>
      <DoublebarChart/> */}
     
    </>
  );
};

export default Page2;



